const PACKAGE_VERSION = "1.21.2";
const TARGETED_RPC_VERSION = "1.43.0";
export {
  PACKAGE_VERSION,
  TARGETED_RPC_VERSION
};
//# sourceMappingURL=version.js.map
